import React, { useState, useRef, useEffect } from 'react';
import css from './ShopByGenreCarousel.module.css'

const ShopByGenreCarousel = ({ genreBlocks }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const containerRef = useRef(null);

    const scrollToSlide = (index) => {
        if (containerRef.current) {
            const slides = containerRef.current.children;
            if (slides[index]) {
                slides[index].scrollIntoView({
                    behavior: 'smooth',
                    inline: 'start',
                    block: 'nearest'
                });
                setCurrentIndex(index);
            }
        }
    };

    const nextSlide = () => {
        const nextIndex = Math.min(currentIndex + 1, genreBlocks.length - 1);
        scrollToSlide(nextIndex);
    };

    const prevSlide = () => {
        const prevIndex = Math.max(currentIndex - 1, 0);
        scrollToSlide(prevIndex);
    };

    // Update current index when user scrolls manually
    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const handleScroll = () => {
            const slides = container.children;
            const containerRect = container.getBoundingClientRect();
            
            for (let i = 0; i < slides.length; i++) {
                const slideRect = slides[i].getBoundingClientRect();
                const slideCenter = slideRect.left + slideRect.width / 2;
                const containerCenter = containerRect.left + containerRect.width / 2;
                
                if (Math.abs(slideCenter - containerCenter) < slideRect.width / 2) {
                    setCurrentIndex(i);
                    break;
                }
            }
        };

        container.addEventListener('scroll', handleScroll);
        
        return () => {
            container.removeEventListener('scroll', handleScroll);
        };
    }, [genreBlocks?.length]);

    return (
        <div className={css.shopByGenreCarouselContainer}>

            <div
                className={css.carouselViewport}
                ref={containerRef}
            >
                {genreBlocks?.map((i, index) => {
                    const title = i.title.content;
                    const media = i.media;
                    const link = media?.link?.href;
                    const imageUrl = media?.image?.attributes?.variants?.original800?.url;
                    const alt = media?.alt;

                    return (
                        <div key={index} className={css.genreCard} id='home-shop-by-genre-card'>
                            <a href={link || '#'} className={css.genreCardLink}>
                                <div className={css.genreCardImage}>
                                    {imageUrl && <img src={imageUrl} alt={alt || title} />}
                                </div>
                                <h3 className={css.genreCardTitle}>
                                    {title}
                                </h3>
                            </a>
                        </div>
                    );
                })}
            </div>
            <div className={css.carouselControls}>
                <button
                    className={css.navButton}
                    onClick={prevSlide}
                    disabled={currentIndex === 0}
                >
                    ←
                </button>
                {/* <span className={css.pagination}>
                    {currentIndex + 1} / {genreBlocks?.length || 0}
                </span> */}
                <button
                    className={css.navButton}
                    onClick={nextSlide}
                    disabled={currentIndex === genreBlocks?.length - 1}
                >
                    →
                </button>
            </div>
        </div>
    );
};

export default ShopByGenreCarousel;